import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { categoryApi, gmtsApi } from '@services/api'

const initialState = {
  isLoading: false,
  foodCategoryGroups: [],
  defaultMarks: []
}

export const getFoodCategoryGroup = createAsyncThunk(
  'topPage/getFoodCategoryGroup',
  async () => {
    const response = await categoryApi.getFoodCategoryGroup()
    return response.data
  }
)

export const getDefaultMark = createAsyncThunk(
  'topPage/getDefaultMark',
  async () => {
    const response = await gmtsApi.getDefaultMark()
    return response.data
  }
)

const topPageSlice = createSlice({
  name: 'topPage',
  initialState,
  reducers: {
    setLoading: (state, action) => {
      state.isLoading = action.payload
    }
  },
  extraReducers: builder => {
    builder.addCase(getFoodCategoryGroup.fulfilled, (state, action) => {
      state.foodCategoryGroups = action.payload
    })
    builder.addCase(getDefaultMark.fulfilled, (state, action) => {
      state.defaultMarks = action.payload
    })
  }
})

export const {
  setLoading
} = topPageSlice.actions

export default topPageSlice.reducer
